import { createBrowserHistory } from "history";
// export let history = createBrowserHistory({ basename: "/semble_app" });
export let history = createBrowserHistory({ basename: "/" });
